import { Component, ElementRef, OnInit, Renderer2, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { CreditCardService } from './credit-card.service';
import { CreditCardCongif } from './interfaces/credit-card-config.interface';
import { CARD_PATTERN } from './configs/credit-card-pattern.config';
import { CardPattern } from './interfaces/card-pattern.interface';
import { removeAllWhiteSpaces } from './helpers/string.helper';

@Component({
  selector: 'd-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit {

  @ViewChild('creditCardRef', { static: true })
  creditCardRef!: ElementRef;

  @ViewChild('creditCardFrontRef', { static: true })
  creditCardFrontRef!: ElementRef;

  @ViewChild('creditCardBackRef', { static: true })
  creditCardBackRef!: ElementRef;

  @ViewChild('creditCardNumbersRef', { static: true })
  creditCardNumbersRef!: ElementRef;

  @ViewChild('creditCardPersonNameRef', { static: true })
  creditCardPersonNameRef!: ElementRef;

  @ViewChild('creditCardMonthYearRef', { static: true })
  creditCardMonthYearRef!: ElementRef;

  @ViewChild('creditCardCVCRef', { static: true })
  creditCardCVCRef!: ElementRef;

  @ViewChild('creditCardLogoRef', { static: true })
  creditCardLogoRef!: ElementRef;

  @Input()
  labelInitialCardNumber!: string;

  @Input()
  labelInitialDateValid!: string;

  @Input()
  labelInitialPersonName!: string;

  @Input()
  labelMonthYear!: string;

  @Input()
  labelValidUntilText!: string;

  @Input()
  labelInitialCVC!: string;

  @Input()
  labelTextFooter!: string;

  @Input() creditCardNumberInputRef!: ElementRef;
  @Input() creditCardPersonNameInputRef!: ElementRef;
  @Input() creditCardDateValidInputRef!: ElementRef;
  @Input() creditCardCVCInputRef!: ElementRef;

  @Output() creditFoundName = new EventEmitter();

  creditCardNumber?: string;
  creditCardPersonName?: string;
  creditCardDateValid?: string;
  creditCardCVC?: string;

  initialConfig!: CreditCardCongif;
  cardPatterns = CARD_PATTERN;

  private lastCardNameRegistered!: string;

  constructor(private creditCardService: CreditCardService, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.getInitialConfig();
    this.getDefaultValueInput();
    this.listenCardNumberInputRefs();
    this.listenCardPersonNameInputRefs();
    this.listenCardValidToInputRefs();
    this.listenCardCVCInputRefs();
  }


  private getDefaultValueInput() {
    setTimeout(() => {
      const textValueCardNumber = this.creditCardNumberInputRef.nativeElement.value;
      const textValuePersonName = this.creditCardPersonNameInputRef.nativeElement.value;
      const textValueValidTo = this.creditCardDateValidInputRef.nativeElement.value;
      const textCVC = this.creditCardCVCInputRef.nativeElement.value;

      this.validateCard(textValueCardNumber);
      this.creditCardPersonName = textValuePersonName;
      this.creditCardDateValid = textValueValidTo;
      this.creditCardCVC = textCVC;

    }, 0);
  }

  private listenCardNumberInputRefs() {
    this.renderer.listen(this.creditCardNumberInputRef.nativeElement, 'focus', () => {
      this.renderer.addClass(this.creditCardNumbersRef.nativeElement, 'credit-card__number--focused');
    });

    this.renderer.listen(this.creditCardNumberInputRef.nativeElement, 'blur', () => {
      this.renderer.removeClass(this.creditCardNumbersRef.nativeElement, 'credit-card__number--focused');
    });

    this.renderer.listen(this.creditCardNumberInputRef.nativeElement, 'keyup', (e) => {
      const textValue = e.target.value;
      this.validateCard(textValue);
    });
  }

  private validateCard(cardNumber: string) {
    const cardNumberTrimed = removeAllWhiteSpaces(cardNumber);
    this.creditCardNumber = cardNumber;
    const cardMatch = this.validateCardWithPatterns(cardNumberTrimed);
    cardMatch ? this.changeTypeCard(cardMatch) : this.removeTypeCard();

    if (!cardNumberTrimed) {
      this.renderer.removeClass(this.creditCardRef.nativeElement, 'credit-card--not-empty');
      this.renderer.addClass(this.creditCardFrontRef.nativeElement, 'credit-card__front--invalid');
      this.renderer.addClass(this.creditCardBackRef.nativeElement, 'credit-card__back--invalid');
      alert('XDDD');

    } else {
      this.renderer.removeClass(this.creditCardFrontRef.nativeElement, 'credit-card__front--invalid');
      this.renderer.removeClass(this.creditCardBackRef.nativeElement, 'credit-card__back--invalid');
      this.renderer.addClass(this.creditCardRef.nativeElement, 'credit-card--not-empty');
    }
  }

  private listenCardPersonNameInputRefs() {
    this.renderer.listen(this.creditCardPersonNameInputRef.nativeElement, 'focus', () => {
      this.renderer.addClass(this.creditCardPersonNameRef.nativeElement, 'credit-card__person-name--focused');
    });

    this.renderer.listen(this.creditCardPersonNameInputRef.nativeElement, 'blur', () => {
      this.renderer.removeClass(this.creditCardPersonNameRef.nativeElement, 'credit-card__person-name--focused');
    });

    this.renderer.listen(this.creditCardPersonNameInputRef.nativeElement, 'keyup', (e) => {
      const textValue = e.target.value;
      this.creditCardPersonName = textValue;
    });
  }

  private listenCardValidToInputRefs() {

    this.renderer.listen(this.creditCardDateValidInputRef.nativeElement, 'focus', () => {
      this.renderer.addClass(this.creditCardMonthYearRef.nativeElement, 'credit-card__digit-month-year--focused');
    });

    this.renderer.listen(this.creditCardDateValidInputRef.nativeElement, 'blur', () => {
      this.renderer.removeClass(this.creditCardMonthYearRef.nativeElement, 'credit-card__digit-month-year--focused');
    });

    this.renderer.listen(this.creditCardDateValidInputRef.nativeElement, 'keyup', (e) => {
      const textValue = e.target.value;
      this.creditCardDateValid = textValue;
    });
  }

  private listenCardCVCInputRefs() {
    console.log(this.creditCardCVCInputRef, 'EQUIS');
    this.renderer.listen(this.creditCardCVCInputRef.nativeElement, 'focus', () => {
      this.renderer.addClass(this.creditCardCVCRef.nativeElement, 'credit-card__cvc-txt--focused');
      this.renderer.addClass(this.creditCardRef.nativeElement, 'credit-card--back');
    });

    this.renderer.listen(this.creditCardCVCInputRef.nativeElement, 'blur', () => {
      this.renderer.removeClass(this.creditCardCVCRef.nativeElement, 'credit-card__cvc-txt--focused');
      this.renderer.removeClass(this.creditCardRef.nativeElement, 'credit-card--back');
    });

    this.renderer.listen(this.creditCardCVCInputRef.nativeElement, 'keyup', (e) => {
      const textValue = e.target.value;
      this.creditCardCVC = textValue;
    });
  }

  private getInitialConfig(): void {
    this.initialConfig = this.creditCardService.getConfig();
  }

  private validateCardWithPatterns(creditCardNumber: string) {
    return this.cardPatterns.find(card => card.pattern.test(creditCardNumber));
  }

  private removeTypeCard() {
      this.renderer.removeClass(this.creditCardLogoRef.nativeElement, `card-credit--${this.lastCardNameRegistered}`);
      this.renderer.setStyle(this.creditCardFrontRef.nativeElement, 'background', '#5f5a5a');
      this.renderer.setStyle(this.creditCardBackRef.nativeElement, 'background', '#5f5a5a');
  }

  private changeTypeCard(cardMatch: CardPattern) {
    this.creditFoundName.emit(cardMatch.cardName);
    this.renderer.removeClass(this.creditCardLogoRef.nativeElement, `card-credit--${this.lastCardNameRegistered}`);
    this.lastCardNameRegistered = cardMatch.cardName;
    this.renderer.addClass(this.creditCardLogoRef.nativeElement, `card-credit--${cardMatch.cardName}`);

    this.renderer.removeClass(this.creditCardFrontRef.nativeElement, 'credit-card__front--invalid');
    this.renderer.removeClass(this.creditCardBackRef.nativeElement, 'credit-card__back--invalid');

    this.renderer.setStyle(this.creditCardFrontRef.nativeElement, 'background', cardMatch.backgroundColor);
    this.renderer.setStyle(this.creditCardBackRef.nativeElement, 'background', cardMatch.backgroundColor);
  }
}
